export default __webpack_public_path__ + "static/media/Short Stay.39c06635.jpg";